// extracted by mini-css-extract-plugin
module.exports = {"button":"GoogleAuth_button__iiNbL","icon":"GoogleAuth_icon__2svQZ"};